function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M1 14c-.256 0-.512-.098-.707-.293-.39-.39-.39-1.023 0-1.414L5.586 7 .293 1.707c-.39-.39-.39-1.023 0-1.414.391-.39 1.023-.39 1.414 0l6 6c.391.391.391 1.023 0 1.414l-6 6c-.195.195-.45.293-.707.293",
  transform: "translate(-16 -13) translate(4 1) translate(12 12) matrix(-1 0 0 1 8 5)"
}))))));

function SvgIconRear({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    style: {
      transform: "rotate(180deg)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRear);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBzdHlsZT0idHJhbnNmb3JtOnJvdGF0ZSgxODBkZWcpOyI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGZpbGw9ImN1cnJlbnRDb2xvciI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xIDE0Yy0uMjU2IDAtLjUxMi0uMDk4LS43MDctLjI5My0uMzktLjM5LS4zOS0xLjAyMyAwLTEuNDE0TDUuNTg2IDcgLjI5MyAxLjcwN2MtLjM5LS4zOS0uMzktMS4wMjMgMC0xLjQxNC4zOTEtLjM5IDEuMDIzLS4zOSAxLjQxNCAwbDYgNmMuMzkxLjM5MS4zOTEgMS4wMjMgMCAxLjQxNGwtNiA2Yy0uMTk1LjE5NS0uNDUuMjkzLS43MDcuMjkzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYgLTEzKSB0cmFuc2xhdGUoNCAxKSB0cmFuc2xhdGUoMTIgMTIpIG1hdHJpeCgtMSAwIDAgMSA4IDUpIi8+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };